<template>
  <div>
    <!-- 条件form -->
    <div class="condition-title">
      <el-select v-model="priority" placeholder="请选择" size="small">
        <el-option
          v-for="item in priorityOptions"
          :key="item"
          :label="`优先级 ${item + 1}`"
          :value="item"
        ></el-option>
      </el-select>

      <el-button type="text" @click="openSelectConditionsDialog">编辑条件</el-button>
    </div>
    <el-form :model="conditionFormData" label-width="100px">
      <el-form-item v-for="item in selectedConditions" :key="item.code" :prop="item.code">
        <condition-form-item
          :type="item.type"
          :config="item"
          :currentEditNode="currentEditNode"
          :ref="item.code"
        />
      </el-form-item>
    </el-form>

    <!-- 选择条件弹窗 -->
    <Modal v-model="selectConditionModalSataus" title="选择流程判断条件" @on-ok="confirmSelectCondition">
      <div class="condition-modal-content">
        <el-checkbox-group v-model="editSelectedConditionCodes">
          <el-checkbox :label="item.code" v-for="item in conditions" :key="item.code">{{item.name}}</el-checkbox>
        </el-checkbox-group>
        <p class="condition-notice">
          <i class="el-icon-info"></i>
          <span>{{selectConditionTip}}</span>
        </p>
      </div>
    </Modal>
  </div>
</template>

<script>
import ConditionFormItem from "./conditionFormItem";

const selectConditionTip =
  "请根据需要选择启用的判断条件，启用多个判断条件时，必需全部满足才会触发此流程分支。";
const priorityLevel = [
  {
    id: "first",
    label: "一级"
  },
  {
    id: "second",
    label: "二级"
  }
];

const initialConditionFormData = {
  // priority: "",
  employees: [],
  departments: [],
  selectedConditionCodes: []
};
export default {
  components: {
    ConditionFormItem
  },

  props: {
    currentEditNode: {
      type: Object
    },
    moddle: {
      type: Object
    },
    modeling: {
      type: Object
    },
    conditions: {
      type: Array
    },

    coditionsSum: {
      type: Number
    },

    conditonPriority: {
      type: Number
    },

    currentBpmnEl: {
      type: Object
    },

    rootElement: {
      type: Object
    },

    eventBus: {
      type: Object
    }
  },

  computed: {
    selectedConditions() {
      return this.conditions.filter(
        item => this.selectedConditionCodes.indexOf(item.code) > -1
      );
    },

    priorityOptions() {
      return [...Array(this.coditionsSum).keys()];
    }
  },

  watch: {
    conditonPriority: {
      immediate: true,

      handler(newValue) {
        this.priority = newValue;
      }
    }
  },

  data() {
    return {
      priority: "",
      selectEmployeeWidgetStatus: true,
      priorityLevel: priorityLevel,
      selectConditionModalSataus: false,
      selectConditionTip: selectConditionTip,
      selectedConditionCodes: [],
      editSelectedConditionCodes: [],
      defaultEmployees: [],
      conditionFormData: this.$js.deepCopyObj(initialConditionFormData)
    };
  },
  methods: {
    openSelectConditionsDialog() {
      this.selectConditionModalSataus = true;
      this.editSelectedConditionCodes = this.$js.deepClone(
        this.selectedConditionCodes
      );
    },

    confirmSelectCondition() {
      this.selectedConditionCodes = this.$js.deepClone(
        this.editSelectedConditionCodes
      );
    },

    initFormData(initData) {
      if (!initData) {
        this.selectedConditionCodes = this.conditions.map(item => item.code);
        return;
      }
      this.selectedConditionCodes = Object.keys(initData);
      this.$nextTick(() => {
        this.selectedConditionCodes.forEach(item => {
          this.$refs[item][0].setConditionValue(initData[item]);
        });
      });
    },
    getErrorMessage() {
      let errorMessage = [];
      this.selectedConditionCodes.forEach(item => {
        errorMessage.push(this.$refs[item][0].validateConditon());
      });
      return errorMessage;
    },

    validateForm() {
      const errorMessage = this.getErrorMessage();

      for (let index = 0; index < errorMessage.length; index++) {
        const element = errorMessage[index];

        if (typeof element !== "boolean") {
          this.$message.error(element);

          return false;
        }
      }
      return true;
    },

    createdBpmnSetting() {
      let conditionExpression = [];
      this.selectedConditionCodes.forEach(item => {
        conditionExpression.push(this.$refs[item][0].getConditionExpression());
      });

      this.setConditionExpression(
        this.currentEditNode,
        this.conditionExpressionToString(conditionExpression)
      );

      this.setPriority();
    },

    setPriority() {
      let {
        id,
        businessObject,
        source: { outgoing }
      } = this.currentBpmnEl;

      const index = outgoing.findIndex(connection => connection.id === id);

      this.currentBpmnEl.source.outgoing.splice(index, 1);

      this.currentBpmnEl.source.outgoing.splice(
        this.priority,
        0,
        this.currentBpmnEl
      );

      this.addModelerListener(this.currentBpmnEl.source.outgoing);
    },

    addModelerListener(outgoing) {
      this.eventBus.on("saveXML.start", function(e) {
        e.definitions.rootElements[0].flowElements = e.definitions.rootElements[0].flowElements.filter(
          moddleElement => {
            const connection = outgoing.find(
              connection => connection.id === moddleElement.id
            );

            return !connection;
          }
        );

        const moddleElements = outgoing.map(
          connection => connection.businessObject
        );
        e.definitions.rootElements[0].flowElements.push(...moddleElements);
      });
    },

    getDocument() {
      let documentText = {};
      this.selectedConditionCodes.forEach(item => {
        documentText[item] = this.$refs[item][0].getDocumentation();
      });
      return documentText;
    },

    conditionExpressionToString(conditions) {
      var expression = "";
      conditions = conditions.filter(e => e && e != "()");
      expression = `\${${conditions.join("&&") || true}}`;
      return expression;
    },

    setDocumentText() {
      let {
        id,
        businessObject,
        source: { outgoing }
      } = this.currentBpmnEl;

      const index = outgoing.findIndex(connection => connection.id === id);

      this.currentBpmnEl.source.outgoing.forEach((item, index) => {
        this.modeling.updateProperties(item, { name: `优先级${index + 1}` });
      });
    },

    /**
     * bpmn XML 设置
     */
    setConditionExpression(bpmnNode, expression) {
      var conditionExpression = this.moddle.create("bpmn:FormalExpression", {
        body: expression
      });
      bpmnNode.conditionExpression = conditionExpression;
    },

    setDocument(bpmnNode, documentText) {
      var documentation = this.moddle.create("bpmn:Documentation");
      documentation.text = documentText;
      bpmnNode.set("documentation", []);
      bpmnNode.documentation.push(documentation);
    },

    clearBpmnSetting(bpmnNode) {
      delete bpmnNode.conditionExpression;
      delete bpmnNode.documentation;
    }
  }
};
</script>

<style scoped lang="scss">
.condition-modal-content {
  width: 480px;
  margin: 0 auto;
}
.el-checkbox {
  width: 120px;
  height: 40px;
  line-height: 40px;
}

.condition-notice {
  color: #909399;
  text-indent: 10px;
  margin-top: 10px;
}
::v-deep .el-divider {
  margin-top: 10px !important;
}
.condition-title {
  height: 40px;
  margin: 20px 20px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .el-select {
    width: 120px;
  }
}

::v-deep .ivu-modal-wrap,
::v-deep .ivu-modal-mask {
  z-index: 10000 !important;
}

::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
</style>